import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import withRouter from "../../withRouter/withRouter";
import Article from "./articlePage";
import {ACGetArticlesById} from "../../../context/reducers/articlesReducer";
import {ThunkCretorGetArticles} from "../../../context/reducers/articlesReducer";
function ArticleContainer(props)
{
    if(props.articles==null)
        props.getArticles();
    else{
        props.getArticle(ACGetArticlesById(+props.router.params.id));
        return (
            <Article value = {props.article}/>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        article : state.articles.currentArticle,
        articles : state.articles.data
    }
};


const mapDispatchToProps = (dispatch)=>({
    getArticle: (action) => {
      dispatch(action);
    },
    getArticles: () => {
        dispatch(ThunkCretorGetArticles());
      }
});
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter
)(ArticleContainer);